import * as Animate from "react-reveal";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import GroupSubNav from "../../../components/layout/GroupSubNav";
import CommunityImage from "../../../assets/images/png/scholarship-community.webp";

const ScholarshipHeaderSection = () => {
  return (
    <header className="w-full relative bg-white overflow-hidden">
      <HeaderNavigation />
      <GroupSubNav />

      <div className="px-6 lg:px-8 pt-10 lg:pt-[74px] pb-8 lg:pb-12">
        <div className="container mx-auto scholarship-grid-hero grid items-center gap-10 lg:gap-[58px]">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-5">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                Utiva Scholarships
              </p>

              <p className="text-[#6f7890] font-poppins text-[15px] font-semibold -mt-2 mb-[18px]">
                Impact &amp; Resources
              </p>

              <h1
                className="max-w-[720px] text-primary font-poppins tracking-[-0.055em] font-black mb-6"
                style={{
                  fontSize: "clamp(38px, 5.5vw, 76px)",
                  lineHeight: 1.03,
                }}
              >
                Talent is everywhere. Access to opportunity should be{" "}
                <mark
                  className="bg-secondary text-primary px-1"
                  style={{
                    boxDecorationBreak: "clone",
                    WebkitBoxDecorationBreak: "clone",
                  }}
                >
                  too.
                </mark>
              </h1>

              <p className="max-w-[680px] text-gray font-poppins text-lg leading-[1.78]">
                Utiva scholarship partnerships help people overcome financial
                barriers and enter practical technology learning pathways.
              </p>

              <div className="flex flex-wrap items-center gap-5 mt-8">
                <a
                  href="mailto:admissions@utiva.co?subject=Current%20Utiva%20Scholarships"
                  className="text-white bg-primary font-poppins min-h-[54px] px-[22px] py-[14px] rounded-xl inline-flex items-center justify-center gap-[11px] font-bold text-[15px] hover:bg-[#03045f] hover:-translate-y-0.5 transition-all focus:outline-none"
                  style={{ boxShadow: "0 14px 34px rgba(5,7,148,0.17)" }}
                >
                  Ask about current opportunities
                  <span aria-hidden="true">↗</span>
                </a>
                <a
                  href="mailto:impact@utiva.co?subject=Fund%20a%20Utiva%20Scholarship"
                  className="text-primary font-poppins text-base font-bold underline underline-offset-4 hover:opacity-80 transition-opacity"
                >
                  Fund a scholarship <span aria-hidden="true">↓</span>
                </a>
              </div>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <div>
              <figure
                className="relative rounded-[30px] overflow-hidden bg-primary min-h-[380px] lg:h-[610px] m-0"
                style={{ boxShadow: "0 30px 70px rgba(20,27,68,0.2)" }}
              >
                <img
                  src={CommunityImage}
                  alt="Members of the Utiva community celebrating learning progress"
                  className="absolute inset-0 w-full h-full object-cover"
                  style={{ objectPosition: "center 28%" }}
                />
                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    top: "28%",
                    background:
                      "linear-gradient(transparent, rgba(3,4,95,0.95))",
                  }}
                ></div>
                <figcaption className="absolute z-10 bottom-[22px] lg:bottom-[30px] left-[21px] lg:left-[30px] right-[21px] lg:right-[30px]">
                  <span className="block text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-2.5">
                    Learning Access
                  </span>
                  <strong className="block max-w-[520px] text-white font-poppins text-2xl lg:text-[29px] leading-[1.3]">
                    Sponsored learning can be the first step in a much longer
                    career story.
                  </strong>
                </figcaption>
              </figure>
              <p className="text-gray font-poppins text-xs lg:text-sm mt-3 lg:text-right">
                Photography from the Utiva community.
              </p>
            </div>
          </Animate.Fade>
        </div>
      </div>
    </header>
  );
};

export default ScholarshipHeaderSection;
